import { ContractPack } from '@core/models/contract-pack/contract-pack.model';
import { ContractThemaNegoChannelCondition } from '@core/models/contract-thema-nego-channel-condition.model';
import { ContractThemaNegoCondition } from '@core/models/contract-thema-nego-condition.model';
import { Target } from '@core/models/target.model';

export interface JsonContractThemaNegotiation {
  id?: number;
  contractItemId?: number;
  isGuaranteed?: boolean;
  target?: Target;
  startDate?: string;
  endDate?: string;
  value?: number;
  nctRate?: number;
  contractPack?: ContractPack;
  isActive?: number;
  updatedAt?: Date;
  conditions?: ContractThemaNegoCondition[];
  channelConditions?: ContractThemaNegoChannelCondition[];
}

export class ContractThemaNego {
  id: number;
  contractItemId: number;
  isGuaranteed?: boolean;
  target?: Target;
  startDate?: string;
  endDate?: string;
  value?: number;
  nctRate?: number;
  contractPack?: ContractPack;
  isActive?: number;
  updatedAt?: Date;
  conditions?: ContractThemaNegoCondition[];
  channelConditions?: ContractThemaNegoChannelCondition[];

  constructor(jsonContractThemaNegotiation: JsonContractThemaNegotiation = null) {
    this.id = jsonContractThemaNegotiation?.id;
    this.contractItemId = jsonContractThemaNegotiation?.contractItemId;
    this.isGuaranteed = jsonContractThemaNegotiation?.isGuaranteed;
    this.target = jsonContractThemaNegotiation?.target;
    this.startDate = jsonContractThemaNegotiation?.startDate;
    this.endDate = jsonContractThemaNegotiation?.endDate;
    this.value = jsonContractThemaNegotiation?.value;
    this.nctRate = jsonContractThemaNegotiation?.nctRate;
    this.contractPack = jsonContractThemaNegotiation?.contractPack;
    this.isActive = jsonContractThemaNegotiation?.isActive;
    this.updatedAt = jsonContractThemaNegotiation?.updatedAt;
    this.conditions = jsonContractThemaNegotiation?.conditions;
    this.channelConditions = jsonContractThemaNegotiation?.channelConditions;
  }
}
